"use client";

import { ChevronUp, ChevronDown } from "lucide-react";

export function ScrollButtons() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2">
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-background/90 text-muted-foreground shadow-md backdrop-blur transition-colors hover:bg-accent hover:text-foreground"
        aria-label="맨 위로"
      >
        <ChevronUp className="h-5 w-5" />
      </button>
      <button
        onClick={() =>
          window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: "smooth",
          })
        }
        className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-background/90 text-muted-foreground shadow-md backdrop-blur transition-colors hover:bg-accent hover:text-foreground"
        aria-label="맨 아래로"
      >
        <ChevronDown className="h-5 w-5" />
      </button>
    </div>
  );
}
